import * as React from 'react'
import * as st from './actionBox.module.scss'
import { Spinner } from '@amzn/dvui/dist/Spinner'

type WrapperComponent = { children?: React.ReactNode, className?: string }

export const DisableOverlay = ({ children = null, className = '' }: WrapperComponent) => (
  <div className={[className, st.disableOverlay].join(' ')}>
    {children}
  </div>
)

type TransactionOverlayProps = { text?: string, useSmallSpinner?: boolean, className?: string }
export const TransactionOverlay = ({ text, useSmallSpinner = false, className = '' }: TransactionOverlayProps) => {

  return (
    <DisableOverlay className={className}>
      <div className={st.messageWrapper}>
        <div className={useSmallSpinner ? st.smallSpinnerWrapper : st.spinnerWrapper}><Spinner fillHeight testID='dp-spinner'/></div>
        {text && <div>{text}</div>}
      </div>
    </DisableOverlay>
  )
}